import {IEnumListEntry} from "../definitions";
export const CURRENCY_TYPES = {
    INNER: 0,
    RUR: 1,
    USD: 2,
    EUR: 3
};


export const CURRENCY_TYPES_LIST:IEnumListEntry[] = [
    { id: CURRENCY_TYPES.INNER, label: "INNER" },
    { id: CURRENCY_TYPES.RUR, label: "RUR" },
    { id: CURRENCY_TYPES.USD, label: "USD" },
    { id: CURRENCY_TYPES.EUR, label: "EUR" }
];


// WEBPACK FOOTER //
// /opt/app/develop/src/app/enums/e-currency.ts